const CaseItemsType = Object.freeze({
  PRODUCT_ORDER: "PRODUCT_ORDER",
  ENTIRE_ORDER: "ENTIRE_ORDER",
  SHIPPING_BOX: "SHIPPING_BOX",
  NO_ITEM: "NO_ITEM",
});

export default CaseItemsType;
